// extracted by mini-css-extract-plugin
export default {"root":"V4M9p_V4M9p","open":"l5VGJ_l5VGJ","more":"yriEX_yriEX","danger":"mZ90e_mZ90e","warning":"tJo9U_tJo9U"};